// Leaderboard.jsx
import React, { useState } from 'react';
import GlobalLeaderboardView from './GlobalLeaderboardView';
import FriendsLeaderboard from './FriendsLeaderboard';
import '../../Style/Leaderboard.css';

const Leaderboard = () => {
  const [activeTab, setActiveTab] = useState('global');

  return (
    <div className="activity-container">
      {' '}
      {/* Use the same container class */}
      <header className="activity-header">
        {' '}
        {/* Use the same header class */}
        <div>
          <h1>Leaderboard</h1>
          <p className="leaderboard-subtitle">See how your progress stacks up.</p>
        </div>
        {/* THE TAB SWITCHER - Now matches ActivityPage structure */}
        <div className="toggle-container">
          <button
            className={`toggle-btn ${activeTab === 'global' ? 'active' : ''}`}
            onClick={() => setActiveTab('global')}
          >
            Global
          </button>
          <button
            className={`toggle-btn ${activeTab === 'friends' ? 'active' : ''}`}
            onClick={() => setActiveTab('friends')}
          >
            Following
          </button>
        </div>
      </header>
      {/* RENDER THE CORRECT VIEW */}
      <div className="lb-view-container">
        {activeTab === 'global' ? <GlobalLeaderboardView /> : <FriendsLeaderboard />}
      </div>
    </div>
  );
};

export default Leaderboard;
